/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeHourglassIcon16Light } from './TimeHourglassIcon16Light';
import { TimeHourglassIcon16Regular } from './TimeHourglassIcon16Regular';
import { TimeHourglassIcon16Solid } from './TimeHourglassIcon16Solid';
import { TimeHourglassIcon20Light } from './TimeHourglassIcon20Light';
import { TimeHourglassIcon20Regular } from './TimeHourglassIcon20Regular';
import { TimeHourglassIcon20Solid } from './TimeHourglassIcon20Solid';
import { TimeHourglassIcon24Regular } from './TimeHourglassIcon24Regular';
import { TimeHourglassIcon24Solid } from './TimeHourglassIcon24Solid';
import { TimeHourglassIcon32Regular } from './TimeHourglassIcon32Regular';
import { TimeHourglassIcon64Regular } from './TimeHourglassIcon64Regular';
var sizes = {
    16: {
        light: TimeHourglassIcon16Light,
        regular: TimeHourglassIcon16Regular,
        solid: TimeHourglassIcon16Solid,
    },
    20: {
        light: TimeHourglassIcon20Light,
        regular: TimeHourglassIcon20Regular,
        solid: TimeHourglassIcon20Solid,
    },
    24: {
        regular: TimeHourglassIcon24Regular,
        solid: TimeHourglassIcon24Solid,
    },
    32: {
        regular: TimeHourglassIcon32Regular,
    },
    64: {
        regular: TimeHourglassIcon64Regular,
    },
};
export var TimeHourglassIcon = forwardRef('TimeHourglassIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
